import { Card, CardBody, Stack, StackDivider } from '@chakra-ui/react';
import BPCCardRow from 'common/components/BPCCardRow';
import { Championnat } from '../championnat.types';

export default function ChampionnatPersonnaliseDetail({
  championnat,
}: {
  championnat: Championnat;
}) {
  return (
    <Card>
      <CardBody>
        <Stack divider={<StackDivider />} spacing="4">
          <BPCCardRow titre="Statut">
            {championnat.isActive ? 'En cours' : 'Fermé'}
          </BPCCardRow>
          <BPCCardRow titre="Tournois personnalisés">
            Cette fonctionnalité sera disponible prochainement.
          </BPCCardRow>
        </Stack>
      </CardBody>
    </Card>
  );
}
